exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-group-addon.flag > img {\n    margin-top: -2px;\n}\n", ""]);

// exports
